import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ContactRequest } from '../../services/http/contacts/contacts.interface';
import { MunicipalityManagement } from '../../services/http/municipalities/municipalities.interface';
import { AlertService } from '../../services/alert/alert.service';
import { AlertType } from '../../services/alert/alert.interface';
import { ContactsService } from '../../services/http/contacts/contacts.service';
import { MunicipalitiesService } from '../../services/http/municipalities/municipalities.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-contact-page',
  standalone: true,
  imports: [FormsModule, CommonModule, RouterLink],
  templateUrl: './contact-page.component.html',
  styleUrl: './contact-page.component.scss'
})
export class ContactPageComponent {
  municipalities: MunicipalityManagement[] = [];
  captchaImage: string = '';
  newContact: ContactRequest = {
    record: undefined,
    type: '',
    name: '',
    email: '',
    subject: '',
    municipality: '',
    description: '',
    flagProtection: false,
    flagSms: false,
    flagEmail: false,
    flagLanguage: '',
    captcha: {
        identifier: '',
        token: ''
    }
  };

  constructor(
    private readonly contactsService: ContactsService,
    private readonly municipalitiesService: MunicipalitiesService,
    private readonly alertService: AlertService
  ) { }

  ngOnInit() {
    this.contactsService.getCaptcha().subscribe((data) => {
      this.newContact.captcha.identifier = data.identifier;
      // add to cpatcha base64 format
      this.captchaImage = "data:image/png;base64," + data.image;
    });
    this.municipalitiesService.getMunicipalitiesManagement().subscribe((data) => {
      this.municipalities = data.municipalities;
    });
  }

  createContact() {
    if (!this.newContact.flagProtection) {
      this.alertService.setAlert({
        message: $localize`:@@Contact.FlagProtection:Debe aceptar la protección de datos`,
        type: AlertType.Warning,
        dismissible: true,
        dismissOnTimeout: 2000
      });
      return;
    }
    if (!this.newContact!.flagEmail && !this.newContact!.flagSms) {
      this.alertService.setAlert({
        message: $localize`:@@Profile.NoCommunication:Debe seleccionar al menos un medio de comunicación.`,
        type: AlertType.Error,
        dismissible: true,
        dismissOnTimeout: 2000
      });
      return;
    }
    // check requireds
    if (!this.newContact.type || !this.newContact.name || !this.newContact.email || !this.newContact.subject || !this.newContact.description || !this.newContact.captcha.token) {
      this.alertService.setAlert({
        message: $localize`:@@Contact.RequiredFields:Faltan campos obligatorios`,
        type: AlertType.Warning,
        dismissible: true,
        dismissOnTimeout: 2000
      });
      return;
    }
    if (this.newContact.municipality == '') {
      this.newContact.municipality = undefined;
    } 
    this.contactsService.createContact(this.newContact).subscribe(() => {
      this.alertService.setAlert({
        message: $localize`:@@Contact.CreatedContac:Petición enviada correctamente`,
        type: AlertType.Success,
        dismissible: true,
        dismissOnTimeout: 2000
      });
      this.resetForm();
    });
  }

  reloadCaptcha(): void {
    this.contactsService.getCaptcha().subscribe((data) => {
      this.newContact.captcha.identifier = data.identifier;
      this.captchaImage = "data:image/png;base64," + data.image;
    });
  }

  resetForm(): void {
    this.newContact = {
      record: undefined,
      type: '',
      name: '',
      email: '',
      subject: '',
      municipality: undefined,
      description: '',
      flagProtection: false,
      flagSms: false,
      flagEmail: false,
      flagLanguage: '',
      captcha: {
          identifier: '',
          token: ''
      }
    };
  }
}
